/*
  Sunburst RPG: no pre-selected size (added 2026-09-11).

  Customers were buying a small by accident because Dawn checks the first size on page load.
  On any product whose Size option has two or more values, this leaves Size blank on arrival,
  shows "Select a size" on the add-to-cart button and blocks the add until the shopper picks
  a size themselves. Color stays pre-selected because it drives the product image.

  - A deliberate link with ?variant= still preselects, on the main product page only.
  - Only a real shopper action (click, tap, key press, screen reader activation) counts as
    choosing a size. Automatic picks by apps such as Camouflage do not.
  - Works for the main product page, quick-add popups and featured-product sections.
  - One-size products and mugs (11oz / 15oz) are left alone.
*/
(function () {
  if (window.sunburstSizeRequired) return;
  window.sunburstSizeRequired = true;

  var SIZE_LABEL = /^\s*size\b/i;
  var BUTTON_TEXT = 'Select a size';
  var ERROR_TEXT = 'Please select a size';
  var INTENT_WINDOW_MS = 1500;

  function sizeFieldset(root) {
    var fieldsets = root.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && SIZE_LABEL.test(legend.textContent)) return fieldsets[i];
    }
    return null;
  }

  function sizeRadios(fieldset) {
    return fieldset ? Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]')) : [];
  }

  // Mugs (11oz / 15oz) keep their pre-selected size; Paula's call, 2026-09-11.
  var MUG_SIZE = /^\s*\d+\s*oz\s*$/i;

  function needsSize(root) {
    var radios = sizeRadios(sizeFieldset(root));
    if (radios.length < 2) return false;
    return !radios.every(function (input) {
      return MUG_SIZE.test(input.value);
    });
  }

  function submitButton(root) {
    return root.querySelector('product-form [type="submit"][name="add"]');
  }

  function isMainProduct(root) {
    return root.dataset.updateUrl === 'true' && !root.closest('quick-add-modal');
  }

  function urlHasVariant() {
    return new URLSearchParams(window.location.search).has('variant');
  }

  function stripVariantFromUrl() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('variant')) return;
    params.delete('variant');
    var query = params.toString();
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + (query ? '?' + query : '') + window.location.hash
    );
  }

  function showError(root) {
    var wrapper = root.querySelector('.product-form__error-message-wrapper');
    var message = wrapper && wrapper.querySelector('.product-form__error-message');
    if (wrapper && message) {
      message.textContent = ERROR_TEXT;
      wrapper.hidden = false;
    }
    var fieldset = sizeFieldset(root);
    if (!fieldset) return;
    fieldset.classList.add('sb-size-needed');
    var first = sizeRadios(fieldset).filter(function (input) {
      return !input.disabled && input.offsetParent !== null;
    })[0];
    if (first) {
      first.focus({ preventScroll: true });
      fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function clearError(root) {
    var wrapper = root.querySelector('.product-form__error-message-wrapper');
    var message = wrapper && wrapper.querySelector('.product-form__error-message');
    if (wrapper && message && message.textContent === ERROR_TEXT) {
      wrapper.hidden = true;
      message.textContent = '';
    }
    var fieldset = sizeFieldset(root);
    if (fieldset) fieldset.classList.remove('sb-size-needed');
  }

  function unlock(root) {
    var button = submitButton(root);
    if (button && button.hasAttribute('data-sb-size-lock')) {
      button.removeAttribute('data-sb-size-lock');
      button.removeAttribute('aria-disabled');
      var label = button.querySelector('span');
      if (label && label.textContent.trim() === BUTTON_TEXT) {
        label.textContent = button.disabled ? window.variantStrings.soldOut : window.variantStrings.addToCart;
      }
    }
    root.querySelectorAll('.shopify-payment-button[data-sb-size-lock]').forEach(function (el) {
      el.removeAttribute('data-sb-size-lock');
      el.inert = false;
    });
    clearError(root);
  }

  // Bring the page back to "no size chosen". Safe to call repeatedly: it only writes when
  // something differs, so it cannot loop with the observer that calls it.
  function apply(root) {
    if (root.sbSizeChosen || !needsSize(root)) {
      unlock(root);
      return;
    }

    var fieldset = sizeFieldset(root);
    sizeRadios(fieldset).forEach(function (input) {
      if (input.checked) input.checked = false;
      if (input.hasAttribute('checked')) input.removeAttribute('checked');
    });
    if (root.sbSizeError) fieldset.classList.add('sb-size-needed');

    var button = submitButton(root);
    if (button) {
      if (!button.hasAttribute('data-sb-size-lock')) button.setAttribute('data-sb-size-lock', '');
      if (button.disabled) button.disabled = false;
      if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
      var label = button.querySelector('span');
      if (label && label.textContent !== BUTTON_TEXT) label.textContent = BUTTON_TEXT;
    }

    root.querySelectorAll('.shopify-payment-button').forEach(function (el) {
      if (!el.hasAttribute('data-sb-size-lock')) el.setAttribute('data-sb-size-lock', '');
      if (!el.inert) el.inert = true;
    });

    // Picking a color makes Dawn write ?variant=<first size> into the address bar. Remove it,
    // otherwise going back to this page later would look like a deliberate size link.
    if (isMainProduct(root)) stripVariantFromUrl();
  }

  function init(root) {
    if (!root || root.sbSizeInit) return;
    root.sbSizeInit = true;
    root.sbSizeChosen = isMainProduct(root) && urlHasVariant();
    root.sbSizeIntentAt = 0;

    // A real person touching the size choices. Screen readers send a trusted click with no
    // pointer or key event first, so clicks count too. Scripted clicks are not trusted.
    ['pointerdown', 'keydown', 'click'].forEach(function (type) {
      root.addEventListener(
        type,
        function (event) {
          if (!event.isTrusted) return;
          var fieldset = sizeFieldset(root);
          if (fieldset && fieldset.contains(event.target)) root.sbSizeIntentAt = Date.now();
        },
        true
      );
    });

    root.addEventListener(
      'change',
      function (event) {
        var fieldset = sizeFieldset(root);
        if (!fieldset || !fieldset.contains(event.target)) return;
        if (Date.now() - root.sbSizeIntentAt > INTENT_WINDOW_MS) {
          // An app picked a size on its own. Undo it once the page has settled.
          setTimeout(function () {
            apply(root);
          }, 0);
          return;
        }
        root.sbSizeChosen = true;
        root.sbSizeError = false;
        unlock(root);
      },
      true
    );

    new MutationObserver(function () {
      apply(root);
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'checked'] });

    apply(root);
  }

  // Block the add while no size is chosen. Capture phase, so this runs before Dawn's handler.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      var root = form.closest('product-info');
      if (!root || root.sbSizeChosen || !needsSize(root)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      root.sbSizeError = true;
      showError(root);
    },
    true
  );

  document.addEventListener('product-info:loaded', function (event) {
    var root = event.target && event.target.closest ? event.target.closest('product-info') : null;
    init(root);
  });

  function scan() {
    document.querySelectorAll('product-info').forEach(init);
  }
  scan();
  document.addEventListener('DOMContentLoaded', scan);
})();
